// import React, { useState, useEffect } from 'react';
// import { toAbsoluteUrl } from './AssetHelpers';
// import { useAuth } from '../../app/modules/auth';

// interface AccordionItemProps {
//     id: number;
//     title: string;
//     country: string;
//     processedBetween: string;
//     imageSrc: string;
//     organization: string;
//     description: string;
//     certifications: string;
//     expandedAccordion: number | null;
//     onToggle: (id: number) => void;
// }

// interface DdpCProps {
//     user: any;
// }

// const IdCall: React.FC<DdpCProps> = ({ user }) => {
//     console.log("yoyo", user?.productionId);

//     // Make API call with token
//     useEffect(() => {
//         if (user?.productionId) {
//             // Get token from localStorage
//             const authData = localStorage.getItem('kt-auth-react-v');
//             let token = null;

//             if (authData) {
//                 try {
//                     const parsedAuthData = JSON.parse(authData);
//                     token = parsedAuthData?.data?.token;
//                 } catch (error) {
//                     console.error('Error parsing auth data:', error);
//                 }
//             }

//             // Create headers object properly
//             const headers: Record<string, string> = {
//                 'Content-Type': 'application/json'
//             };

//             if (token) {
//                 headers['Authorization'] = `Bearer ${token}`;
//             }

//             // Make API call with Authorization header
//             fetch(`${process.env.REACT_APP_BASE_API_URL?.replace('/v1', '') || ''}trace/${user.productionId}?orderType=PRODUCTION`, {
//                 method: 'GET',
//                 headers: headers
//             })
//                 .then(response => {
//                     if (!response.ok) {
//                         throw new Error(`HTTP error! status: ${response.status}`);
//                     }
//                     return response.json();
//                 })
//                 .then(data => console.log('API Response:', data))
//                 .catch(error => console.error('API Error:', error));
//         }
//     }, [user?.productionId]);

//     // Add early return if user is not loaded yet
//     if (!user) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div>

//         </div>
//     );
// };

// export default IdCall;





import { userInfo } from 'os';
// import React from 'react';
import React, { useState, useEffect } from 'react';
import { FC, useRef } from 'react'
interface User {
    id: string;
    name: string;
    productionIds: number[];
    registryId: string
    // Add other user properties as needed
}

interface ProductionReceiptProps {
    user: any;
    // user: User;
}


const lineStyle = {
    marginTop: '1px',
    borderTop: '1px solid #000', // Adjust the color and width as needed
}

const IdCall: React.FC<ProductionReceiptProps> = ({ user }) => {
    console.log("user loadeddddddd", user);


    const certificateRef = useRef<HTMLDivElement>(null)
    const downloadCertificate = () => {
        if (!certificateRef.current) return;

        // Find all canvas elements (QR codes) and convert them to images
        const canvases = certificateRef.current.querySelectorAll('canvas');
        const canvasReplacements: { canvas: HTMLCanvasElement; img: HTMLImageElement }[] = [];

        canvases.forEach(canvas => {
            try {
                const img = document.createElement('img');
                // img.src = canvas.touserURL('image/png');
                img.width = canvas.width;
                img.height = canvas.height;
                img.style.cssText = canvas.style.cssText;

                // Replace canvas with image temporarily
                canvas.parentNode?.insertBefore(img, canvas);
                canvas.style.display = 'none';

                canvasReplacements.push({ canvas, img });
            } catch (error) {
                console.error('Error converting canvas to image:', error);
            }
        });

        // Wait for images to load
        setTimeout(() => {
            const printContent = certificateRef.current?.innerHTML;
            const originalContent = document.body.innerHTML;

            // const printStyles = `
            //   <style>
            //     body { font-family: Inter, Arial, sans-serif; margin: 20px; }
            //     .table { width: 100%; border-collapse: collapse; }
            //     .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            //     .table th { background-color: #f8f9fa; font-weight: bold; }
            //     .row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
            //     .col-3 { flex: 0 0 25%; max-width: 25%; padding: 0 15px; }
            //     .col-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
            //     .col-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
            //     .col-9 { flex: 0 0 75%; max-width: 75%; padding: 0 15px; }
            //     .col-11 { flex: 0 0 91.666667%; max-width: 91.666667%; padding: 0 15px; }
            //     .col-12 { flex: 0 0 100%; max-width: 100%; padding: 0 15px; }
            //     .text-center { text-align: center; }
            //     .fw-bold { font-weight: bold; }
            //     img { max-width: 100%; height: auto; }
            //     .image-input-wrapper { 
            //       background-size: cover; 
            //       background-position: center; 
            //       background-repeat: no-repeat; 
            //     }
            //   </style>
            // `;

            //         const printStyles = `
            //       <style>
            //         body { font-family: Inter, Arial, sans-serif; margin: 20px; }
            //         .table { width: 100%; border-collapse: collapse; }
            //         .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            //         .table th { background-color: #f8f9fa; font-weight: bold; }
            //         .row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
            //         .col-3 { flex: 0 0 25%; max-width: 25%; padding: 0 15px; }
            //         .col-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
            //         .col-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
            //         .col-9 { flex: 0 0 75%; max-width: 75%; padding: 0 15px; }
            //         .col-11 { flex: 0 0 91.666667%; max-width: 91.666667%; padding: 0 15px; }
            //         .col-12 { flex: 0 0 100%; max-width: 100%; padding: 0 15px; }
            //         .col-lg-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
            //         .col-lg-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
            //         .text-center { text-align: center; }
            //         .fw-bold { font-weight: bold; }
            //         .fs-6 { font-size: 1rem; }

            //         /* Prevent images from breaking across pages */
            //         img { 
            //           max-width: 100%; 
            //           height: auto; 
            //           page-break-inside: avoid;
            //           break-inside: avoid;
            //         }

            //         .image-input-wrapper {
            //           background-size: cover;
            //           background-position: center;
            //           background-repeat: no-repeat;
            //           page-break-inside: avoid;
            //           break-inside: avoid;
            //         }

            //         .image-input {
            //           page-break-inside: avoid;
            //           break-inside: avoid;
            //         }

            //         /* Remove the row page-break rule that was causing the empty first page */

            //         .row .col-lg-4 {
            //           display: inline-block;
            //           vertical-align: top;
            //           width: 33.333333%;
            //         }
            //         .row .col-lg-8 {
            //           display: inline-block;
            //           vertical-align: top;
            //           width: 66.666667%;
            //         }
            //            .chain-item {
            //   page-break-inside: avoid !important;
            //   break-inside: avoid !important;
            //   display: block !important;
            //   margin-bottom: 20px !important;
            // }

            // /* Ensure the timeline container doesn't break */
            // .timeline-container {
            //   page-break-inside: avoid !important;
            //   break-inside: avoid !important;
            // }
            //   .timeline-line {
            //   page-break-inside: avoid !important;
            //   break-inside: avoid !important;
            //   position: absolute !important;
            // }

            // /* Keep timeline items together */
            // .timeline-container {
            //   position: relative !important;
            // }

            // /* Ensure continuous line */
            // .timeline-line::before {
            //   content: '' !important;
            //   position: absolute !important;
            //   top: -20px !important;
            //   left: 0 !important;
            //   width: 100% !important;
            //   height: 20px !important;
            //   background-color: #007a7d !important;
            // }
            // /* Force sections to flow together */
            // .custody-section {
            //   page-break-after: avoid !important;
            //   break-after: avoid !important;
            //   margin-bottom: 0 !important;
            // }

            // .process-section {
            //   page-break-before: avoid !important;
            //   break-before: avoid !important;
            //   margin-top: 0 !important;
            // }

            // /* Remove large gaps between sections */
            // .section-break {
            //   display: none !important;
            // }

            // /* Ensure continuous flow */
            // .chain-of-custody-wrapper {
            //   page-break-inside: auto !important;
            //   break-inside: auto !important;
            // }
            //       </style>
            //     `;






            const printStyles = `
    <style>
      body { 
        font-family: Inter, Arial, sans-serif; 
        margin: 20px; 
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      
      /* Basic table styles */
      table { 
        width: 100%; 
        border-collapse: collapse; 
        margin-bottom: 1rem;
      }
      table th, table td { 
        border: 1px solid #d1d5db; 
        padding: 8px; 
        text-align: left; 
        font-size: 1.075rem;
      }
      table th { 
        background-color: #e6f7f7 !important; 
        font-weight: bold; 
        color: #447a7d !important;
      }
      
      /* Flexbox layouts */
      .row { 
        display: flex; 
        flex-wrap: wrap; 
        margin: 0 -15px; 
      }
      .col-3 { flex: 0 0 25%; max-width: 25%; padding: 0 15px; }
      .col-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
      .col-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
      .col-9 { flex: 0 0 75%; max-width: 75%; padding: 0 15px; }
      .col-12 { flex: 0 0 100%; max-width: 100%; padding: 0 15px; }
      
      /* Text utilities */
      .text-center { text-align: center; }
      .fw-bold { font-weight: bold; }
      .fs-6 { font-size: 1rem; }
      
      /* Section containers */
      div[style*="border: 1px solid #e0e0e0"] {
        border: 1px solid #e0e0e0 !important;
        border-radius: 8px !important;
        background-color: white !important;
        box-shadow: 0 1px 4px rgba(0,0,0,0.1) !important;
        margin-bottom: 20px !important;
        overflow: visible !important;
        page-break-inside: avoid !important;
      }
      
      /* Section headers */
      div[style*="backgroundColor: '#e6f7f7'"],
      div[style*="background-color: '#e6f7f7'"] {
        background-color: #e6f7f7 !important;
        padding: 12px 20px !important;
        border-bottom: 1px solid #e0e0e0 !important;
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
      }
      
      /* Section content */
      div[style*="padding: '20px'"] {
        padding: 20px !important;
        display: block !important;
      }
      
      /* Flexible field containers */
      div[style*="display: 'flex'"][style*="flexWrap: 'wrap'"] {
        display: flex !important;
        flex-wrap: wrap !important;
        gap: 20px !important;
        margin-bottom: 20px !important;
      }
      
      /* Field containers */
      div[style*="flex: '0 0 auto'"] {
        flex: 0 0 auto !important;
        min-width: auto !important;
      }
      
      /* Field labels */
      div[style*="fontFamily: \"'Roboto'\""][style*="fontSize: '1rem'"][style*="fontWeight: 400"] {
        font-family: 'Roboto', 'Roboto Fallback', sans-serif !important;
        font-size: 1rem !important;
        font-weight: 400 !important;
        color: #282828 !important;
        margin-bottom: 8px !important;
      }
      
      /* Field values */
      div[style*="backgroundColor: '#f8f8f8'"] {
        background-color: #f8f8f8 !important;
        border-radius: 2px !important;
        padding: 6px 12px !important;
        display: inline-block !important;
        min-width: 80px !important;
        font-weight: bold !important;
      }
      
      /* Images */
      img { 
        max-width: 100% !important; 
        height: auto !important; 
        page-break-inside: avoid !important;
      }
      
      img[style*="borderRadius: '50%'"] {
        width: 40px !important;
        height: 40px !important;
        border-radius: 50% !important;
        object-fit: cover !important;
        border: 2px solid #e5e7eb !important;
      }
      
      /* Timeline and chain of custody */
      .chain-item {
        page-break-inside: avoid !important;
        margin-bottom: 20px !important;
        position: relative !important;
      }
      
      .timeline-line {
        position: absolute !important;
        left: 40px !important;
        top: 0px !important;
        bottom: -10px !important;
        width: 2px !important;
        background-color: #007a7d !important;
        z-index: 1 !important;
      }
      
      /* Page break controls */
      .page-break-avoid {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      
      /* Ensure all content is visible */
      * {
        visibility: visible !important;
        opacity: 1 !important;
      }
    </style>
  `;

            document.body.innerHTML = printStyles + (printContent || '');

            setTimeout(() => {
                window.print();

                // Restore original content
                document.body.innerHTML = originalContent;

                // Restore canvas elements
                canvasReplacements.forEach(({ canvas, img }) => {
                    canvas.style.display = '';
                    img.remove();
                });

                window.location.reload();
            }, 500);
        }, 1000);
    };





    // import React, { useState, useEffect } from 'react';





    useEffect(() => {
        if (user?.productionId) {
            // Get token from localStorage
            const authData = localStorage.getItem('kt-auth-react-v');
            let token = null;

            if (authData) {
                try {
                    const parsedAuthData = JSON.parse(authData);
                    token = parsedAuthData?.data?.token;
                } catch (error) {
                    console.error('Error parsing auth data:', error);
                }
            }

            // Create headers object properly
            const headers: Record<string, string> = {
                'Content-Type': 'application/json'
            };

            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            // Make API call with Authorization header
            fetch(`${process.env.REACT_APP_BASE_API_URL?.replace('/v1', '') || ''}trace/${user.productionId}?orderType=PRODUCTION`, {
                method: 'GET',
                headers: headers
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => console.log('API Response:', data))
                .catch(error => console.error('API Error:', error));
        }
    }, [user?.productionId]);










    return (
        <>
            {/* <button
                style={{ backgroundColor: '#12B886', color: "white" }}
                className='btn btn-light-primary me-3 mb-4'
                type='button'
                onClick={downloadCertificate}
            >
                Print
            </button> */}
            <div ref={certificateRef} className="print-container" style={{ maxWidth: '64rem', margin: '0 auto', padding: '1.5rem', backgroundColor: 'white' }}>

                {/* <img
                    src="/BGImg.png"
                    alt="background"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'fill',
                        opacity: 0.5,
                        zIndex: 1,
                        pointerEvents: 'none',
                    }}
                /> */}



                {/* <img
                src="/BGImg.png"
                alt="background"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    opacity: 1,
                    zIndex: 1,
                    pointerEvents: 'none',
                }}
            /> */}



                <img
                    src="/BGImg.png"
                    alt="background"
                    style={{
                        position: 'absolute',
                        top: '-1.5rem',          // Offset by negative padding
                        left: '-1.5rem',         // Offset by negative padding  
                        width: 'calc(100% + 3rem)',  // Add padding back
                        height: 'calc(100% + 3rem)', // Add padding back
                        objectFit: 'cover',
                        opacity: 0,
                        zIndex: -1,
                        pointerEvents: 'none',
                    }}
                />



                {/* Header */}
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
                <h1
                    style={{
                        fontSize: '32px',
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        lineHeight: '40px',
                        padding: '21px 40px',
                    }}
                >Production receipt</h1> <br />

                <div style={{ marginBottom: '1.5rem', fontSize: "1.075rem" }}>
                    <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Date : </span>
                    <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>2025-06-23</span>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <img
                        src="/BGImg.png"
                        alt="background"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            opacity: 1,
                            zIndex: -1,  // Change from 1 to -1
                            pointerEvents: 'none',
                        }}
                    />
                </div>
            </div> */}

                {/* <div style={{ marginBottom: '1.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                    <h1
                        style={{
                            fontSize: '32px',
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            lineHeight: '40px',
                            // padding: '21px 40px',
                            margin: 0, // Remove default margin
                        }}
                    >Production receipt</h1>

                    <div style={{ textAlign: 'right' }}>
                        <img
                            src="/BGImg.png"
                            alt="background"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                opacity: 1,
                                zIndex: -1,
                                pointerEvents: 'none',
                            }}
                        />
                    </div>
                </div>

                <div style={{ fontSize: "1.075rem", }}>
                    <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Registry No : </span>
                    <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>{user.registryId}</span>
                </div>
                <div style={{ fontSize: "1.075rem" }}>
                    <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Document No : </span>
                    <span style={{ fontSize: "1.075rem", color: '#2563eb' }}></span>
                </div>
                <div style={{ fontSize: "1.075rem" }}>
                    <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Date : </span>
                    <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>2025-06-23</span>
                </div>
            </div> */}


                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1
                        style={{
                            fontSize: '32px',
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            lineHeight: '40px',
                            // padding: '21px 40px',
                            margin: 0,
                        }}
                    >
                        Registry Document
                    </h1>
                    <img
                        style={{
                            backgroundColor: 'rgb(255, 255, 255)',
                            marginTop: '1px',
                            width: '150px',        // Add width
                            height: '150px',       // Add height
                            objectFit: 'contain'  // Maintain aspect ratio
                        }}
                        src="/BGImgl.png"
                        alt="main-logo"
                    />
                </div>

                {/* Date section below */}
                {/* <div style={{ fontSize: "1.075rem", }}>
                <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Registry No : </span>
                <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>{user.registryId}</span>
            </div>
            <div style={{ fontSize: "1.075rem" }}>
                <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Document No : </span>
                <span style={{ fontSize: "1.075rem", color: '#2563eb' }}></span>
            </div>
            <div style={{ fontSize: "1.075rem" }}>
                <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Date : </span>
                <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>2025-06-23</span>
            </div> */}


                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '1rem'
                }}>
                    {/* Left side - Registry info */}
                    <div>
                        <div style={{ fontSize: "1.075rem", marginBottom: '0.5rem' }}>
                            <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Registry No : </span>
                            <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>{user.registryId}</span>
                        </div>
                        <div style={{ fontSize: "1.075rem", marginBottom: '0.5rem' }}>
                            <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Document No : </span>
                            <span style={{ fontSize: "1.075rem", color: '#2563eb' }}></span>
                        </div>
                        <div style={{ fontSize: "1.075rem" }}>
                            <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Date : </span>
                            <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>2025-06-23</span>
                        </div>
                    </div>

                    {/* Right side - Image */}
                    <div style={{
                        width: '9rem',
                        height: '9rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '50%',  // Changed from '0.25rem' to '50%' for round shape
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <img
                            src={user?.user?.[0]?.kycDocuments?.docUrl}
                            alt="KYC Document"
                            style={{
                                width: '150%',
                                height: '150%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                </div>

                {/* <div style={{ marginTop: '-10px', borderTop: '1px solid #000' }}></div> */}

                {/* Date */}


                {/* Facility information */}
                <div style={{ marginBottom: '1.5rem', marginTop: "20px", }}>



                    {/* <img
                        src="/BGImg.png"
                        alt="background"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'fill',
                            opacity: 0.5,
                            zIndex: 1,
                            pointerEvents: 'none',
                        }}
                    /> */}
                    <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', marginBottom: '0.75rem', color: 'black' }}>Facility information</h2>
                    <div style={{ marginTop: '-10px', borderTop: '1px solid #000' }}></div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '1rem', fontSize: "1.075rem" }}>
                        <div style={{ gridColumn: 'span 8' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', fontSize: '0.875rem' }}>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Business name</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: {user?.user?.[0]?.pickupPointInfo?.name}</div>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Address</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: {user?.user?.[0]?.pickupPointInfo?.address?.street}</div>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Location</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: {user?.user?.[0]?.pickupPointInfo?.address?.latitute},{user?.user?.[0]?.pickupPointInfo?.address?.longitute}</div>
                            </div>
                        </div>
                        {/* <div style={{ gridColumn: 'span 4' }}>
                        <div style={{ width: '8rem', height: '6rem', backgroundColor: '#e5e7eb', border: '1px solid #d1d5db', borderRadius: '0.25rem' }}></div>
                    </div> */}

                    </div>
                </div>



                {/* Process name */}
                <div style={{ marginBottom: '1.5rem' }}>
                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                    <span style={{ fontSize: "1.075rem", color: 'black' }}>Process name:</span>
                    <span style={{ backgroundColor: '#e9d5ff', color: '#7c3aed', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: "1.075rem" }}>{user?.user?.[0].processName}</span>
                </div> */}



                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d1d5db', marginBottom: '1rem', backgroundColor: '#ffffff' }}>
                        {/* <thead>
                        <tr style={{ backgroundColor: '#f3f4f6' }}>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>SL</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Type</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Category</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Item</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Quantity</th>
                        </tr>
                    </thead> */}
                        <thead>
                            <tr style={{ backgroundColor: '#e6f7f7' }}>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>SL</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Type</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Category</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Item</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>1</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>Output Material</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>-</td>
                                <td style={{
                                    border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black'
                                }}>{user?.user?.[0]?.productionItemDetails?.[0]?.itemName}</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                    {user?.user?.[0]?.productionItemDetails?.[0]?.quantity} kg</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>2</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>Input Material</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                    {user?.user?.[0]?.inputMaterial?.[0]?.inputMaterialCategoryName}
                                </td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                    {user?.user?.[0]?.inputMaterial?.[0]?.inputMaterialName}
                                </td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                    {user?.user?.[0]?.inputMaterial?.[0]?.inputQuantity} kg
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Process loss</span>
                    <span style={{ backgroundColor: '#fee2e2', color: '#dc2626', padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: "1.075rem" }}> {user?.user[0]?.wastage}</span>
                </div> */}
                </div>

                {/* Production information */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', marginBottom: '0.75rem', color: 'black' }}>Production information</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '1rem' }}>
                        <div style={{ gridColumn: 'span 8' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', fontSize: '0.875rem' }}>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Date</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: 6/23/2025</div>


                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Process name</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>:
                                    {user?.user?.[0]?.processName}
                                </div>


                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Chain of custody</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: Batch traceability</div>

                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Methodology</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: ISO 22095 [Mass balance]</div>
                            </div>
                        </div>
                        <div style={{ gridColumn: 'span 4', textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '1.125rem', marginBottom: '0.5rem', color: 'black' }}>Akbar</div>
                            <div style={{ fontWeight: '500', color: 'black' }}>Signature</div>
                        </div>
                    </div>
                </div>







                {/* <div style={{ marginBottom: '1.5rem' }}>
                <h2 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'black', fontSize: "1.075rem" }}>Certifications</h2>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d1d5db' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f3f4f6' }}>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Name</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Authority</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Number</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Valid till</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                {user?.user[0]?.certifications[0]?.certificationName}
                            </td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: '#2563eb' }}> {user?.user[0]?.certifications[0]?.issuingAuthorities}</td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>{user?.user[0]?.certifications[0]?.certificationNo}</td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>{user?.user[0]?.certifications[0]?.validTill?.split('T')[0]}</td>
                        </tr>
                    </tbody>
                </table>
            </div> */}


                {/* <div style={{ marginBottom: '1.5rem' }}>
                <h2 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'black', fontSize: "1.075rem" }}>Audit Information</h2>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d1d5db' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f3f4f6' }}>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Auditor</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Company</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Date</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Remarks</th>
                            <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'center', fontSize: "1.075rem", fontWeight: '500', color: 'black' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                {user?.user[0]?.auditorInfo?.personalDetails?.name}
                            </td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: '#2563eb' }}>
                                {user?.user?.[0]?.auditorInfo?.companyDetails?.name}
                            </td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                {user?.user?.[0]?.approvedAt}
                            </td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                {user?.user?.[0]?.remark}
                            </td>
                            <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'center' }}>
                                <img
                                    src={user?.user?.[0]?.sign}
                                    alt=""
                                    style={{ width: '40px', height: '40px' }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> */}


                <div className="print-sections" style={{
                    display: 'block',
                    width: '100%',
                    position: 'relative',
                    zIndex: 1
                }}>


                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Certifications Details
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                {/* Certification Name */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Name
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.certificationName || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Authority */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Authority
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold",
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            // color: '#2563eb',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.issuingAuthorities || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Certification Number */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Number
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.certificationNo || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Valid till */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Valid till
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.validTill?.split('T')[0] || 'N/A'}
                                        </span>
                                    </div>
                                </div>



                                {/* Add this after the Valid till field in the Certifications Details */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Logo
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        // backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <img
                                            src={user?.user?.[0]?.certifications?.[0]?.logo}
                                            alt={user?.user?.[0]?.certifications?.[0]?.certificationName}
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #e5e7eb',
                                                cursor: 'pointer'  // Add cursor pointer
                                            }}
                                            onClick={() => window.open(user?.user?.[0]?.certifications?.[0]?.logo, '_blank')}  // Add onClick handler
                                        />
                                    </div>
                                </div>

                            </div>

                            {/* Multiple Certifications Support */}
                            {user?.user?.[0]?.certifications?.length > 1 && (
                                <div>
                                    <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                        Additional Certifications
                                    </h4>
                                    {user?.user?.[0].certifications.slice(1).map((cert, index) => (
                                        <div key={index} style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '20px',
                                            marginBottom: '15px',
                                            padding: '10px',
                                            backgroundColor: '#f9f9f9',
                                            borderRadius: '4px'
                                        }}>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Name
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {cert.certificationName || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Authority
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#2563eb'
                                                }}>
                                                    {cert.issuingAuthorities || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Number
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {cert.certificationNo || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Valid till
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {cert.validTill?.split('T')[0] || 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>




                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                KYC documents
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '40px',
                                marginBottom: '20px'
                            }}>
                                {/* Business registration Section */}
                                <div style={{ flex: '0 0 auto', minWidth: '250px' }}>
                                    <h4 style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#007a7d',
                                        marginBottom: '15px'
                                    }}>
                                        Business registration
                                    </h4>

                                    {/* Document number */}
                                    <div style={{ marginBottom: '10px' }}>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document number */}
                                        </div>
                                        <div style={{
                                            backgroundColor: '#f8f8f8',
                                            borderRadius: "2px",
                                            padding: '6px 12px',
                                            display: 'inline-block',
                                            minWidth: '80px',
                                            fontWeight: "bold"
                                        }}>
                                            <span style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: 'bold',
                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                            }}>
                                                {user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE")?.docNumber || 'N/A'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Image */}
                                    <div>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document */}
                                        </div>
                                        <div style={{
                                            width: '100px',
                                            height: '100px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE")?.docUrl}
                                                alt="Business registration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    const poeDoc = user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE");
                                                    if (poeDoc?.docUrl) {
                                                        window.open(poeDoc.docUrl, '_blank');
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Environment Permit Section */}
                                <div style={{ flex: '0 0 auto', minWidth: '250px' }}>
                                    <h4 style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#007a7d',
                                        marginBottom: '15px'
                                    }}>
                                        Environment Permit
                                    </h4>

                                    {/* Document number */}
                                    <div style={{ marginBottom: '10px' }}>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document number */}
                                        </div>
                                        <div style={{
                                            backgroundColor: '#f8f8f8',
                                            borderRadius: "2px",
                                            padding: '6px 12px',
                                            display: 'inline-block',
                                            minWidth: '80px',
                                            fontWeight: "bold"
                                        }}>
                                            <span style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: 'bold',
                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                            }}>
                                                {user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POI")?.docNumber || 'N/A'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Image */}
                                    <div>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document */}
                                        </div>
                                        <div style={{
                                            width: '100px',
                                            height: '100px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POI")?.docUrl}
                                                alt="Environment Permit"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    const poiDoc = user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POI");
                                                    if (poiDoc?.docUrl) {
                                                        window.open(poiDoc.docUrl, '_blank');
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Sponsor Details
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                {/* Sponsor Name */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Name
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.sponsorDetails?.[0]?.sponsorName || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Quantity */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Quantity
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold",
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.sponsorDetails?.[0]?.weight || 'N/A'} kg
                                        </span>
                                    </div>
                                </div>

                                {/* Date of Purchase */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Date of Purchase
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.sponsorDetails?.[0]?.date ?
                                                new Date(user?.user?.[0].sponsorDetails[0].date).toISOString().split('T')[0].replace(/-/g, '/')
                                                : 'N/A'
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Signature Image */}
                            <div>
                                <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                    Signature
                                </h4>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {user?.user?.[0]?.sponsorDetails?.[0]?.sign ? (
                                        <div style={{
                                            width: '80px',
                                            height: '80px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.user?.[0]?.sponsorDetails?.[0]?.sign}
                                                alt="Sponsor Signature"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    position: 'relative',
                                                    zIndex: 10,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.open(user?.user?.[0]?.sponsorDetails?.[0]?.sign, '_blank')}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                            No signature available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden'
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Audit Information
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}



                            {/* Add these after the Remarks field in Audit Information */}

                            {/* Standard */}

                            <div style={{
                                display: 'flex',
                                flexWrap: 'nowrap', // Change from 'wrap' to 'nowrap'
                                gap: '15px',
                                marginBottom: '20px',
                                overflowX: 'auto' // Add scroll if needed
                            }}>
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Standard
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.auditStandard?.[0]?.auditName || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Governing Body */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Governing Body
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.auditStandard?.[0]?.auditAuthorities || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Version Number */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Version Number
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.auditStandard?.[0]?.versionNo || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Logo */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Logo
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        // backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <img
                                            src={user?.user?.[0]?.auditStandard?.[0]?.logo}
                                            alt="Audit Standard Logo"
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #e5e7eb',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => window.open(user?.user?.[0]?.auditStandard?.[0]?.logo, '_blank')}
                                        // onError={(e) => {
                                        //     e.target.src = '/path/to/default-image.png'; // fallback image
                                        // }}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                {/* Auditor */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Auditor
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.auditorInfo?.personalDetails?.name || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Company */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Company
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold",
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            // color: '#2563eb',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.auditorInfo?.companyDetails?.name || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Date */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Date
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.approvedAt ?
                                                new Date(user?.user?.[0].approvedAt).toISOString().split('T')[0].replace(/-/g, '/')
                                                : 'N/A'
                                            }
                                        </span>
                                    </div>
                                </div>

                                {/* Remarks */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Remarks
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.remark || 'N/A'}
                                        </span>
                                    </div>


                                    {/* Add this after the Remarks field in Audit Information */}



                                </div>
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Logo
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        // backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        {/* <img
                                        src={user?.user?.[0]?.auditorInfo?.kycDocument?.[0]?.docUrl}
                                        alt="KYC Document"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            border: '2px solid #e5e7eb',
                                            cursor: 'pointer'  // Add cursor pointer to show it's clickable
                                        }}
                                        onClick={() => window.open(user?.user?.[0]?.auditorInfo?.kycDocument?.[0]?.docUrl, '_blank')}                                   
                                    /> */}



                                        <img
                                            src={user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE")?.docUrl}
                                            alt="KYC Document - POE"
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #e5e7eb',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                const poeDoc = user?.user?.[0]?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE");
                                                if (poeDoc?.docUrl) {
                                                    window.open(poeDoc.docUrl, '_blank');
                                                }
                                            }}
                                        // onError={(e) => {
                                        //     e.target.src = '/path/to/default-image.png'; // fallback image
                                        // }}
                                        />

                                    </div>
                                </div>
                            </div>

                            {/* Signature Image */}
                            <div>
                                <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                    Signature
                                </h4>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {user?.user?.[0]?.sign ? (
                                        <div style={{
                                            width: '80px',
                                            height: '80px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.user?.[0]?.sign}
                                                alt="Signature"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    position: 'relative',
                                                    zIndex: 10,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.open(user?.user?.[0]?.sign, '_blank')}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                            No signature available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>




                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px",
                        marginTop: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Supporting Documents
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Images */}
                            <div>
                                <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                    Documents
                                </h4>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {user?.user?.[0]?.images && user?.user?.[0].images.length > 0 ? (
                                        user?.user?.[0].images.map((imageUrl, imgIndex) => (
                                            <div key={imgIndex} style={{
                                                width: '100px',
                                                height: '100px',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                overflow: 'hidden'
                                            }}>
                                                <img
                                                    src={imageUrl}
                                                    alt={`Document ${imgIndex + 1}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        position: 'relative',
                                                        zIndex: 10,
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => window.open(imageUrl, '_blank')}
                                                />
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                            No documents available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


                {/* Chain of custody */}
                <div style={{ marginBottom: '1.5rem', marginTop: '1.5rem' }}>
                    <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', marginBottom: '0.75rem', color: 'black' }}>Chain of custody</h2>
                </div>


                <div className="chain-of-custody-wrapper">
                    <div className="custody-section">
                        <div className="" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', backgroundColor: 'white' }}>
                            {/* {user?.user?.[0]?.collectionDetails?.map((item, index) => {


                                return ( */}
                            <div className="chain-item" style={{ position: 'relative', marginBottom: '10px', backgroundColor: 'white' }}>
                                {/* Main collection item */}
                                <div style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    backgroundColor: 'white',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                    marginLeft: '60px',
                                    overflow: 'hidden'
                                }}>
                                    {/* Header with Details and expand/collapse arrow */}
                                    <div
                                        style={{
                                            backgroundColor: '#e6f7f7',
                                            padding: '12px 20px',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #e0e0e0'
                                        }}
                                    // onClick={() => toggleCard(index)}
                                    >
                                        <h3 style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#007a7d'
                                        }}>
                                            {/* {item.processName} Details */}
                                        </h3>
                                        <div style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            // color: '#333',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            // transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease',
                                            color: '#007a7d'
                                        }}>
                                            ▼
                                        </div>
                                    </div>

                                    {/* Content area - conditionally rendered */}

                                    <div style={{ padding: '20px' }}>
                                        {/* Flexible field container */}
                                        <div style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '20px',
                                            marginBottom: '20px'
                                        }}>
                                            {/* Batch id */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Batch id
                                                </div>
                                                <div style={{
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: 'bold',
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.batchId || 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Weight */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Weight
                                                </div>
                                                <div style={{
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold",
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: 'bold',
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.usedQuantity} kg */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Process */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Process
                                                </div>
                                                <div style={{
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: 'bold',
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.processName} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Input */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Category
                                                </div>
                                                <div style={{
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: "bold",
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.categoryName ?? 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Item */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Item
                                                </div>
                                                <div style={{
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: "bold",
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.itemName || 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Site */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Site
                                                </div>
                                                <div style={{
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: "bold",
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.pickupPointName || 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Source */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Source
                                                </div>
                                                <div style={{
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: "bold",
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.sourceName || 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Address */}
                                            <div style={{ flex: '0 0 auto', width: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Address
                                                </div>
                                                <div style={{
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold",
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                }}>
                                                    <span style={{ fontSize: '13px', color: '#333' }}>
                                                        {/* {item.sourceAddress || 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Country */}
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                    letterSpacing: 0,
                                                    lineHeight: '22px',
                                                    color: '#282828',
                                                    marginBottom: '8px'
                                                }}>
                                                    Country
                                                </div>
                                                <div style={{
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: "2px",
                                                    padding: '6px 12px',
                                                    display: 'inline-block',
                                                    minWidth: '80px',
                                                    fontWeight: "bold",
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                }}>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        fontWeight: "bold",
                                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                    }}>
                                                        {/* {item.country || 'N/A'} */}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Production Images */}
                                        <div>
                                            <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                                Images
                                            </h4>
                                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                {/* {item.images && item.images.length > 0 ? (
                                                            item.images.map((imageUrl, imgIndex) => (
                                                                <div key={imgIndex} style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '6px',
                                                                    overflow: 'hidden'
                                                                }}>
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt={`Production ${imgIndex + 1}`}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            position: 'relative',
                                                                            zIndex: 10,
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => window.open(imageUrl, '_blank')}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                                                No images available
                                                            </div>
                                                        )} */}
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                {/* Date display - shown for all containers */}
                                <div className="timeline-line" style={{
                                    position: 'absolute',
                                    left: '40px',
                                    top: '0px',
                                    bottom: '-10px',
                                    width: '2px',
                                    backgroundColor: '#007a7d',
                                    zIndex: 1
                                }}></div>
                                <div style={{
                                    position: 'absolute',
                                    left: '34px',
                                    top: '25px',
                                    width: '14px',
                                    height: '14px',
                                    borderRadius: '50%',
                                    backgroundColor: '#007a7d',
                                    border: '3px solid white',
                                    zIndex: 2
                                }}></div>


                                <div style={{
                                    position: 'absolute',
                                    left: '-40px',
                                    top: '20px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    whiteSpace: 'nowrap',
                                    padding: '4px 8px',
                                    // backgroundColor: 'white',
                                    // border: '1px solid #ddd',
                                    // borderRadius: '4px',
                                    // boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                }}>
                                    <div style={{ whiteSpace: 'pre-line' }}>
                                        {/* {`${new Date(item.date).getFullYear()}/${String(new Date(item.date).getMonth() + 1).padStart(2, '0')}/${String(new Date(item.date).getDate()).padStart(2, '0')}\n${new Date(item.date).toLocaleTimeString('en-GB', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                })}`} */}
                                    </div>

                                </div>
                            </div>
                            {/* );
                            })} */}
                        </div>
                    </div>
                    <div className="process-section">
                        <div className="" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', backgroundColor: 'white' }}>
                            {user?.user?.[0]?.processDetails?.map((item, index) => {


                                return (
                                    <div key={index} className="chain-item" style={{ position: 'relative', marginBottom: '10px', backgroundColor: 'white' }}>
                                        {/* Main collection item */}
                                        <div style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                            marginLeft: '60px',
                                            overflow: 'hidden'
                                        }}>
                                            {/* Header with Details and expand/collapse arrow */}
                                            <div
                                                style={{
                                                    backgroundColor: '#e6f7f7',
                                                    padding: '12px 20px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #e0e0e0'
                                                }}
                                            // onClick={() => toggleCard(index)}
                                            >
                                                <h3 style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#007a7d'
                                                }}>
                                                    {item.processName} Details
                                                </h3>
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    // color: '#333',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    // transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease',
                                                    color: '#007a7d'
                                                }}>
                                                    ▼
                                                </div>
                                            </div>

                                            {/* Content area - conditionally rendered */}

                                            <div style={{ padding: '20px' }}>
                                                {/* Flexible field container */}
                                                <div style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '20px',
                                                    marginBottom: '20px'
                                                }}>
                                                    {/* Batch id */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Batch id
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.batchId || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Weight */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Weight
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.usedQuantity} kg
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Process */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Process
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.processName}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Input */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Category
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.categoryName ?? 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Item */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Item
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.itemName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Site */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Site
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.pickupPointName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Source */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Source
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.sourceName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div style={{ flex: '0 0 auto', width: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Address
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                        }}>
                                                            <span style={{ fontSize: '13px', color: '#333' }}>
                                                                {item.sourceAddress || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Country */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Country
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.country || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Production Images */}
                                                <div>
                                                    <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                                        Images
                                                    </h4>
                                                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                        {item.images && item.images.length > 0 ? (
                                                            item.images.map((imageUrl, imgIndex) => (
                                                                <div key={imgIndex} style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '6px',
                                                                    overflow: 'hidden'
                                                                }}>
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt={`Production ${imgIndex + 1}`}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            position: 'relative',
                                                                            zIndex: 10,
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => window.open(imageUrl, '_blank')}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                                                No images available
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                        {/* Date display - shown for all containers */}
                                        <div className="timeline-line" style={{
                                            position: 'absolute',
                                            left: '40px',
                                            top: '0px',
                                            bottom: '-10px',
                                            width: '2px',
                                            backgroundColor: '#007a7d',
                                            zIndex: 1
                                        }}></div>
                                        <div style={{
                                            position: 'absolute',
                                            left: '34px',
                                            top: '25px',
                                            width: '14px',
                                            height: '14px',
                                            borderRadius: '50%',
                                            backgroundColor: '#007a7d',
                                            border: '3px solid white',
                                            zIndex: 2
                                        }}></div>


                                        <div style={{
                                            position: 'absolute',
                                            left: '-40px',
                                            top: '20px',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            color: '#333',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            whiteSpace: 'nowrap',
                                            padding: '4px 8px',
                                            // backgroundColor: 'white',
                                            // border: '1px solid #ddd',
                                            // borderRadius: '4px',
                                            // boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                {`${new Date(item.date).getFullYear()}/${String(new Date(item.date).getMonth() + 1).padStart(2, '0')}/${String(new Date(item.date).getDate()).padStart(2, '0')}\n${new Date(item.date).toLocaleTimeString('en-GB', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                })}`}
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>


                <img
                    src="/footer.png"
                    alt="background"
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                />


            </div>
        </>
    );
};

export default IdCall;